import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import frLocale from '@fullcalendar/core/locales/fr';
import icsToJson from 'ics-to-json';

export default class ICalComponent {

    constructor() {
        this.initCalendar();
    }

    initCalendar() {
        const calendarEl = document.getElementById('ics-calendar');

        $.ajax( {
            url: Theme.ajaxURL,
            type: 'POST',
            data: {
                action: 'ics_data',
                ical_url: Theme.icalURL
            },
            success: function ( icalData ) {

                // Conversion au format json
                let jsonArrayData = icsToJson(icalData);

                // Filtres doublons
                const filteredArrData = jsonArrayData.filter((value, index, self) =>
                        index === self.findIndex((t) => (
                            t.summary === value.summary && t.startDate === value.startDate && t.endDate === value.endDate
                        ))
                )

                // Renommage des clés
                const formatedArrData = filteredArrData.map(event => {
                    return {
                        title: event.summary,
                        start: event.startDate,
                        end: event.endDate,
                        description: event.description,
                    };
                });

                const calendar = new Calendar(calendarEl, {
                    locale: frLocale,
                    plugins: [dayGridPlugin],
                    events: formatedArrData,
                })

                $(calendarEl).find('.wpetStrateLoader').remove();
                calendar.render();
            },
            error: function(error) {
                console.error(error);
                calendarEl.innerHTML = $(calendarEl).data('error-msg');
            }
        } );
    }
}
